import { useHover, useUpdateEffect } from 'ahooks';
import { FC, ReactElement, useRef, useState } from 'react';

import { AppMessage, ButtonSuccess } from '@/common/components';
import { messageOnError } from '@/common/utils';

import { useCheckHealthDomainsMutation } from '@/modules/Domains';

interface Props {
  domainId: string;
  tag: ReactElement;
}

const CheckHealthButton: FC<{ handleClickCheckDomainHealth?: () => void, isCheckHealthLoading?: boolean }> = (props) => {
  const { handleClickCheckDomainHealth, isCheckHealthLoading } = props;
  return (
    <ButtonSuccess
      size="small"
      onClick={ handleClickCheckDomainHealth }
      block
      type="primary"
      loading={ isCheckHealthLoading }
    >
      перевірити
    </ButtonSuccess>
  );
};

export const DomainCheckHealthWithTag: FC<Props> = ({
  domainId,
  tag
}) => {
  const appMessageApi = AppMessage.useControls();

  const ref = useRef(null);
  const isHovering = useHover(ref);
  const [showCheck, setShowCheck] = useState(false);

  useUpdateEffect(() => {
    if (!isHovering) setShowCheck(false);
  }, [isHovering]);

  const { mutate: checkHealthMutation, isLoading: isCheckHealthLoading } = useCheckHealthDomainsMutation(domainId)({
    onError: (error) => {
      messageOnError(error, appMessageApi);
    }
  });

  const handleClickCheckDomainHealth = () => {
    checkHealthMutation?.();
    setShowCheck(false);
  };

  return (
    <div ref={ ref } style={{ cursor: 'pointer', }}>
      {
        ((showCheck && isHovering) || isCheckHealthLoading)
          ? (
            <CheckHealthButton
              handleClickCheckDomainHealth={ handleClickCheckDomainHealth }
              isCheckHealthLoading={ isCheckHealthLoading }
            />
          )
          // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
          : <div onClick={ () => setShowCheck(true) }>{ tag }</div>
      }
    </div>
  );
};
